import React from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { getHeaders } from "../../../helpers/getHeaders";
import { toast } from "react-toastify";
import { getSeatDescription } from "../../../helpers/getSeatDescription";
import axios from "../../../axios-instance";
import ls from 'localstorage-slim';

const MySwal = withReactContent(Swal);
const closeModalHandler = (e) => {
  MySwal.close();
};


export const ConfirmRefundProductsModal = ({
  products, setActionLoading, getOrders
}) => {

  const token = ls.get('user').token;

  const refundProductsHandler = () => {
    const idsProducts = products.map((product) => product.id);
    setActionLoading(true);
    closeModalHandler();

    axios
      .post(`/OrderManagment/Refund`, idsProducts, {
        headers: getHeaders(token),
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data) {
            toast.success("Products successfully refunded");
            getOrders(token)
            MySwal.close();
          } else {
            toast.error("Products not refunded");
          }
          return;
        }

        throw new Error(response.data.errorMessage);
      })
      .catch((err) => {
        toast.error("Products not refunded");
      })
      .finally(() => {
        setActionLoading(false);
      });
  };

  return (
    <>
      <div className="seats-list">
        <span>Products that will be refunded:</span>
        {products.map((product) => (
          <span key={product.id}>{product.productDefinition.name}</span>
        ))}
      </div>
      <div className="swal2-actions">
        <button
          className="swal2-cancel swal2-styled"
          onClick={closeModalHandler}
        >
          Cancel
        </button>
        <button
          className="swal2-confirm swal2-styled"
          onClick={refundProductsHandler}
        >
          Refund
        </button>
      </div>
    </>
  );
};
